import { render } from "./CreateQuestionPage.vue?vue&type=template&id=edf58e22&scoped=true"
import script from "./CreateQuestionPage.vue?vue&type=script&lang=js"
export * from "./CreateQuestionPage.vue?vue&type=script&lang=js"

import "./CreateQuestionPage.vue?vue&type=style&index=0&id=edf58e22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf58e22"]])

export default __exports__